import i18next from "i18next";

/** Types of form validation errors. The specified strings are purely for making javascript keys more handy
 * to view in debugger -- they should not be displayed in UI. Use getFormValidationErrorMessage below
 * to get the user-facing validation string.
 */
export enum FormValidationErrorType {
    /** This form validation error has no specific type. This should NOT be used for user-facing cases. */
    Unspecified = 'Unspecified',

    // Contour+-specific ROI errors

    /** Contour+: ROI name is empty (or just whitespace). */
    ContourPlusRoiNameIsEmpty = 'ContourPlusRoiNameIsEmpty',

    /** Contour+: duplicate ROI names are not allowed within a single customization output. */
    ContourPlusDuplicateRoiNamesInOutput = 'ContourPlusDuplicateRoiNamesInOutput',


    // DICOM rule and DICOM attribute rule-specific errors

    /** DICOM rule has duplicates of the same attribute. */
    DicomAttributesMustNotRepeat = 'DicomAttributesMustNotRepeat',

    /** DICOM attribute rule name is empty. */
    DicomAttributeNameMustNotBeEmpty = 'DicomAttributeNameMustNotBeEmpty',

    /** DICOM rule has no attributes. */
    DicomRuleMustHaveAtLeastOneAttribute = 'DicomRuleMustHaveAtLeastOneAttribute',

    /** AE Title rule action names must be unique. */
    AeTitlesMustBeUnique = 'AeTitlesMustBeUnique',

    /** Dose+: Ring distances must be in strictly ascending order. */
    DosePlusRingDistancesNotAscending = 'DosePlusRingDistancesNotAscending',

    /** Dose+: Ring distances must not contain duplicate values. */
    DosePlusRingDistancesDuplicate = 'DosePlusRingDistancesDuplicate',
}

/** Gets a localized version of a form validation error message. */
export const getFormValidationErrorMessage = (errorType: FormValidationErrorType) => {
    switch (errorType) {
        case FormValidationErrorType.ContourPlusRoiNameIsEmpty:
            return i18next.t('translation:error.formValidation.contourPlus.roiNameIsEmpty');
        case FormValidationErrorType.ContourPlusDuplicateRoiNamesInOutput:
            return i18next.t('translation:error.formValidation.contourPlus.duplicateRoiNamesInOutput');
        case FormValidationErrorType.DicomAttributesMustNotRepeat:
            return i18next.t('translation:error.formValidation.dicomAttributesMustNotRepeat');
        case FormValidationErrorType.DicomAttributeNameMustNotBeEmpty:
            return i18next.t('translation:error.formValidation.dicomAttributeNameMustNotBeEmpty');
        case FormValidationErrorType.DicomRuleMustHaveAtLeastOneAttribute:
            return i18next.t('translation:error.formValidation.dicomRuleMustHaveAtLeastOneAttribute');
        case FormValidationErrorType.AeTitlesMustBeUnique:
            return i18next.t('translation:error.formValidation.aeTitlesMustBeUnique');
        case FormValidationErrorType.DosePlusRingDistancesNotAscending:
            return i18next.t('translation:error.formValidation.dosePlus.ringDistancesNotAscending');
        case FormValidationErrorType.DosePlusRingDistancesDuplicate:
            return i18next.t('translation:error.formValidation.dosePlus.ringDistancesDuplicate');
        default:
            throw new Error('Unsupported form validation error');
    }
}